import CoreRouter from './core/router'
import Error404 from './views/404'
import routes from './routes'
import HomePage from './views/home'
import { Message } from 'element-ui'
import store from './store'

const router = new CoreRouter({
  mode: 'hash',// history or hash
  base: process.env.BASE_URL
})
const prefix = './views'
// import() 动态函数避免以下使用 https://segmentfault.com/a/1190000015648036
// const page = (name) => () => import('./views/' + name)

router.push([
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  // {
  //   path: '/user',
  //   name: 'user',
  //   label: 'User',
  //   meta: {
  //     auth: true
  //   },
  //   component: () => import(`${prefix}/user`)
  // },
  {
    path: '/auth',
    name: 'auth',
    component: () => import(`${prefix}/auth`)
  }
])



const route404 = {
  path: '*',
  component: Error404
}

routes.push(route404)
router.push(routes)

// 获取真正的Vue Router实例
const vueRouter = router.router()

// 添加全局路由守卫，记录路由跳转日志
vueRouter.beforeEach((to, from, next) => {
  let apiList = (store.state.user && store.state.user.apiList) || [];
  const matchedWithApiName = to.matched.find(record => record.meta && record.meta.apiName)
  
  if (matchedWithApiName) {
    const requiredApiName = matchedWithApiName.meta.apiName;
    
    // 检查权限
    if (apiList.length === 0) {
      return next('/admin'); // 跳转到admin页面
    }
    if (apiList.length > 0 && !apiList.includes(requiredApiName)) {
      Message({
        message: `权限不足: 缺少 ${requiredApiName} 权限`,
        type: 'warning',
        duration: 3000,
      });
      return next('/admin'); // 跳转到admin页面
    }
  }

  next()
})


export default vueRouter;